import { useEffect, useState } from "react";
import { yerelHaftaBasi } from "@koclukpanel/contracts";
import { Buton, DetayliAnaliz, Iskelet, type DetayliAnalizVerisi } from "@koclukpanel/ui";
import { detayliAnalizim, kendiKaydim } from "./api";
import { hataMetni } from "./hata-metni";

/**
 * ANALİZİM — F-ANL-08b (04.10.2026, müşteri revizesi madde 3)
 *
 * "Öğrenci panelinde de detaylı analiz raporlama kısmı bulunmalıdır."
 * Koçun paneldeki detaylı analiziyle AYNI uç ve AYNI bileşen; öğrenci
 * yalnızca hafta değiştirebiliyor (karşılaştırma her zaman bir önceki
 * hafta — iki seçici telefonda kalabalık ve öğrencinin sorusu "geçen
 * haftaya göre nasılım").
 *
 * Hafta başı `yerelHaftaBasi`: UTC ile hesaplansaydı Pazartesi gece
 * 00:00–02:59 arası geçen haftayı açardı (program ekranında yaşandı).
 */
function haftaBasi(kaydirma: number): string {
  const g = yerelHaftaBasi(new Date());
  g.setUTCDate(g.getUTCDate() + kaydirma * 7);
  return g.toISOString().slice(0, 10);
}

export function Analizim() {
  const [kaydirma, setKaydirma] = useState(0);
  const [veri, setVeri] = useState<DetayliAnalizVerisi | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const hafta = haftaBasi(kaydirma);

  useEffect(() => {
    let iptal = false;
    setVeri(null);
    setHata(null);
    void (async () => {
      try {
        const ben = await kendiKaydim();
        const v = await detayliAnalizim(ben.id, hafta);
        if (!iptal) setVeri(v);
      } catch (e) {
        if (!iptal) setHata(hataMetni(e, "Analiz alınamadı."));
      }
    })();
    return () => {
      iptal = true;
    };
  }, [hafta]);

  const secici = (
    <div className="flex items-center justify-between gap-2">
      <Buton gorunum="ikincil" onClick={() => setKaydirma(kaydirma - 1)}>
        ← Önceki
      </Buton>
      <span className="text-notr-700 text-sm font-medium">
        {kaydirma === 0 ? "Bu hafta" : kaydirma === -1 ? "Geçen hafta" : `${-kaydirma} hafta önce`}
      </span>
      <Buton gorunum="ikincil" disabled={kaydirma >= 0} onClick={() => setKaydirma(kaydirma + 1)}>
        Sonraki →
      </Buton>
    </div>
  );

  if (hata) {
    return (
      <div className="flex flex-col gap-3">
        {secici}
        <p role="alert" className="rounded-alan bg-hata-50 text-hata-700 px-3 py-2 text-sm">
          {hata}
        </p>
      </div>
    );
  }
  if (veri === null) {
    return (
      <div className="flex flex-col gap-3">
        {secici}
        <Iskelet satir={5} />
      </div>
    );
  }
  return <DetayliAnaliz veri={veri} ust={secici} />;
}
